import {
    apiRequest,
    AcSosioculturalData,
    AcSosioculturalDetail,
    AcSosioculturalStankom,
    AcSosioculturalMatrix,
    AcDevGuideSosio,
    SuitablePossisionSosio
} from "../../../../../services/adapters/Assesment/assesmentService"

class DetailRepository {

    fetchAcData = async (query) => {
        return await apiRequest("get", AcSosioculturalData, {
            params: query
        }, true)
    }
    fetchAcDetail = async (query) => {
        return await apiRequest("get", AcSosioculturalDetail, {
            params: query
        }, true)
    }
    fetchStankom = async (query) => {
        return await apiRequest("get", AcSosioculturalStankom, {
            params: query
        }, true)
    }
    fetchMatrix = async (query) => {
        return await apiRequest("get", AcSosioculturalMatrix, {
            params: query
        }, true)
    }
    fetchDevGuide = async (query) => {
        return await apiRequest("get", AcDevGuideSosio, {
            params: query
        }, true)
    }
    fetchSuitablePossision = async (query) => {
        return await apiRequest("get", SuitablePossisionSosio, {
            params: query
        }, true)
    }
}

export default DetailRepository